import { auth } from '@/lib/firebase/config';
import { useNavigate } from 'react-router';

interface Result {
  handleSignOut: () => void;
}

export const useSignOut = (): Result => {
  const navigate = useNavigate();
  const handleSignOut = () => {
    auth.signOut();
    navigate('/sign-in');
  };

  return {
    handleSignOut,
  };
};
